module.exports = __webpack_public_path__ + "static/media/4.cd8bb420.svg";